module.exports = __webpack_public_path__ + "img/zhw-icon.a29e6639.png";